import { loadWhatsNewReadState } from 'store/localStorage';
import {
  SET_UNREAD,
  SET_CURRENT_CATEGORY,
  SET_CURRENT_FILTER,
  RESET_UNREAD_COUNTER,
  GET_USER_NOTIFICATIONS,
  GET_USER_NOTIFICATIONS_SUCCESS,
  GET_USER_NOTIFICATIONS_ERROR,
  PUT_FAVOURITE_USER_NOTIFICATION,
  PUT_FAVOURITE_USER_NOTIFICATION_SUCCESS,
  PUT_FAVOURITE_USER_NOTIFICATION_ERROR,
  INCREASE_PAGE,
  DISABLE_LOAD_MORE,
  CLEAR_NOTIFICATIONS,
  SET_IS_OPEN,
  PUSH_NOTIFICATION,
} from './actions';
import { initialCategory, initialFilter, categoriesIds, categories } from '../constants/categories';
import { getUnreadIds } from '../utils';
import { fetchUserNotificationsWhatsNew } from '../services/notificationsService';

const initialState = {
  unread: {
    total: 0,
    whatsNew: 0,
    user: 0,
  },
  currentCategory: initialCategory,
  currentFilter: initialFilter,
  isPending: false,
  notifications: [],
  isFavouritePendings: [],
  page: 1,
  loadMore: true,
  limit: 25,
  isOpen: false,
};

const getCalculatedUnread = async (unread, categoryId, isPending, unreadDisplayed) => {
  if (isPending) {
    return unread;
  }

  switch (categoryId) {
    case categoriesIds.whatsNew: {
      const whatsNewData = (await fetchUserNotificationsWhatsNew()).map(item => item.id);
      const whatsNewRead = loadWhatsNewReadState();

      const unreadItems = whatsNewData.filter(item => !whatsNewRead.includes(item));

      const result = {
        total: unread.total - unreadDisplayed - unreadItems.length,
        whatsNew: unread.whatsNew - unreadDisplayed - unreadItems.length,
        user: unread.user,
      };

      return result;
    }
    case categoriesIds.yourNotifications:
      return {
        total: unread.total - unreadDisplayed,
        whatsNew: unread.whatsNew,
        user: unread.user - unreadDisplayed,
      };
    default:
      return unread;
  }
};

const isCurrentCategoryType = (currentCategory, category) =>
  categories.find(({ id }) => id === currentCategory).types.includes(category);

export const notificationsCentre = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case SET_UNREAD:
      return {
        ...state,
        unread: {
          total: payload.total,
          whatsNew: payload.whatsNew,
          user: payload.user,
        },
      };
    case SET_CURRENT_CATEGORY:
      return {
        ...state,
        currentCategory: payload.id,
      };
    case SET_CURRENT_FILTER:
      return {
        ...state,
        currentFilter: payload.id,
      };
    case RESET_UNREAD_COUNTER:
      return {
        ...state,
        unread: getCalculatedUnread(
          state.unread,
          state.currentCategory,
          state.isPending,
          getUnreadIds(state.notifications).length,
        ),
      };
    case GET_USER_NOTIFICATIONS:
      return {
        ...state,
        isPending: true,
      };
    case GET_USER_NOTIFICATIONS_SUCCESS:
      if (!state.isOpen) {
        return state;
      }

      return {
        ...state,
        isPending: false,
        notifications: [...state.notifications, ...payload],
      };
    case GET_USER_NOTIFICATIONS_ERROR:
      return {
        ...state,
        isPending: false,
      };
    case PUSH_NOTIFICATION:
      if (
        !state.isOpen ||
        state.isPending ||
        !isCurrentCategoryType(state.currentCategory, payload.data.type.category)
      ) {
        return state;
      }

      return {
        ...state,
        isPending: false,
        notifications: [payload.data, ...state.notifications.slice(0, -1)],
      };
    case PUT_FAVOURITE_USER_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.map(item => {
          if (payload.id === item._id) {
            return {
              ...item,
              is_favourite: payload.isFavourite,
            };
          }
          return item;
        }),
        isFavouritePendings: [...state.isFavouritePendings, payload.id],
      };
    case PUT_FAVOURITE_USER_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isFavouritePendings: state.isFavouritePendings.filter(id => payload.id !== id),
      };
    case PUT_FAVOURITE_USER_NOTIFICATION_ERROR:
      return {
        ...state,
        notifications: state.notifications.map(item => {
          if (payload.id === item._id) {
            return {
              ...item,
              is_favourite: !payload.isFavourite,
            };
          }
          return item;
        }),
        isFavouritePendings: [...state.isFavouritePendings.filter(id => payload.id !== id)],
      };
    case INCREASE_PAGE:
      if (state.isPending || !state.loadMore || !state.isOpen) {
        return state;
      }

      return {
        ...state,
        page: state.page + 1,
      };
    case DISABLE_LOAD_MORE:
      return {
        ...state,
        loadMore: false,
      };
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        page: initialState.page,
        loadMore: initialState.loadMore,
        notifications: initialState.notifications,
        isPending: initialState.isPending,
      };
    case SET_IS_OPEN:
      return {
        ...state,
        isOpen: payload.value,
      };
    default:
      return state;
  }
};
